export const ImageDimension = {
    width: 56,
    height: 24,
};

export const ENTER_FRAME_DELAY = 500;

export enum CartType {
    AFFORDABLE_M2 = "AFFORDABLE_M2",
    BOLT_M3 = "BOLT_M3",
    TOING = "TOING",
    DEFAULT = "DEFAULT",
}
